import {Pipe, PipeTransform} from "@angular/core";
import {UtilitiesService} from "../../core/_services/utilities.service";

@Pipe({
    name: 'serviceFilter'
})
export class ServiceFilterPipe implements PipeTransform {

    transform(services: any[]): any {
        if (UtilitiesService.isEmpty(services)) {
            return [];
        }

        const filteredServices = [];
        for (let i = 0; i < services.length; i++) {
            // remove services that have a bundleServiceCode
            if (!services[i].bundleServiceCode) {
                filteredServices.push(services[i]);
            }
        }

        return filteredServices;
    } // transform()

} // ServiceFilterPipe
